import { render } from "./Filtro.vue?vue&type=template&id=a3cf10fa"
import script from "./Filtro.vue?vue&type=script&lang=js"
export * from "./Filtro.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__